import {
	defaultDirection,
	defaultLocale,
	localeOptions,
	themeColorStorageKey,
	themeRadiusStorageKey,
	localeDirectionStorageKey,
	localeStorageKey,
	stripeKeys,
	defaultStripeRegion,
	stripeSubKeyIntentions,
	getDefaultColor,
} from '../configs/main';
import { flavor } from '../configs/defaultValues';

export const getDirection = () => {
	let direction = defaultDirection;
	try {
		if (localStorage.getItem(localeDirectionStorageKey)) {
			const localValue = localStorage.getItem(localeDirectionStorageKey);
			if (localValue === 'rtl' || localValue === 'ltr') {
				direction = localValue;
			}
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getDirection error:', error);
		direction = defaultDirection;
	}
	return {
		direction,
		isRtl: direction === 'rtl',
	};
};
export const setDirection = (localValue) => {
	let direction = 'ltr';
	if (localValue === 'rtl' || localValue === 'ltr') {
		direction = localValue;
	}
	try {
		localStorage.setItem(localeDirectionStorageKey, direction);
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setDirection error:', error);
	}
};

export const getLocale = () => {
	let locale = null;
	try {
		if (localStorage.getItem(localeStorageKey)) {
			const l = localStorage.getItem(localeStorageKey);
			if (localeOptions.find((el) => el.id === l)) {
				locale = l;
			}
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> getCurrentLanguage error:',
			error
		);
		locale = defaultLocale;
	}
	return locale;
};
export const setLocale = (payload) => {
	try {
		localStorage.setItem(localeStorageKey, payload);
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setCurrentLanguage error:',
			error
		);
	}
};

export const getCurrentColor = () => {
	let currentColor = getDefaultColor(flavor);
	try {
		if (localStorage.getItem(themeColorStorageKey)) {
			currentColor = localStorage.getItem(themeColorStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentColor error:', error);
	}
	return currentColor;
};

export const setCurrentColor = (color) => {
	try {
		localStorage.setItem(themeColorStorageKey, color);
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setCurrentColor error:', error);
	}
};

export const getCurrentRadius = () => {
	let currentRadius = 'rounded';
	try {
		if (localStorage.getItem(themeRadiusStorageKey)) {
			currentRadius = localStorage.getItem(themeRadiusStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentRadius error:', error);
		currentRadius = 'rounded';
	}
	return currentRadius;
};
export const setCurrentRadius = (payload) => {
	try {
		localStorage.setItem(themeRadiusStorageKey, payload);
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setCurrentRadius error:', error);
	}
};

export const getEmbedded = () => {
	let embedded = false;
	try {
		embedded = sessionStorage.getItem('embedded') === 'true';
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getEmbedded error:', error);
	}
	return embedded;
};

export const setEmbedded = (embedded) => {
	try {
		sessionStorage.setItem('embedded', embedded);
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setEmbedded error:', error);
	}
};

export const getBaseUrl = () => {
	let baseUrl = null;
	try {
		baseUrl = window.targetStorage.getItem('baseUrl');
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getBaseUrl error:', error);
	}
	return baseUrl;
};

export const setBaseUrl = (url) => {
	try {
		window.targetStorage.setItem('baseUrl', url);
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setBaseUrl error:', error);
	}
};

export const isProxied = () => {
	const { host } = window.location;
	return (
		!/portal.ziicloud.com/i.test(host) &&
		!/portal.myposzero.com.au/i.test(host) &&
		!/portal-forward.hk.ziiforce.com/i.test(host) &&
		!/(gray|qa|dev)/i.test(host) &&
		!/localhost/i.test(host)
		// && !/127.0.0.1/i.test(host)
		// && !/192.168.20.85/i.test(host)
	);
};

export const getUA = () => {
	return navigator.userAgent || '';
};
export const isInApp = () => {
	return /zii/i.test(getUA());
};

export const isZiiMGT = () => {
	return /ZiiMGT/i.test(getUA());
};

export const isZiiPOS = () => {
	return /ziiforce/i.test(getUA());
};

export const isEmbedded = () => {
	return /zii_embedded/i.test(getUA());
};

export const isAndroid = () => {
	return /Android/i.test(getUA());
};

export const isIOS = () => {
	return /iPhone/i.test(getUA()) || /iPad/i.test(getUA());
};

export const isIPhone = () => {
	return /iPhone/i.test(getUA());
};

export const isIPad = () => {
	return /iPad/i.test(getUA());
};

export const isMobile = () => {
	// TODO: Temporary solution.
	return isIOS() || isAndroid() || isZiiMGT();
};

export const isFlutter = () => {
	return /Flutter/i.test(getUA());
};

export const isWX = () => {
	return /MicroMessenger/i.test(getUA());
};

export const isAlipay = () => {
	return /Alipay/i.test(getUA());
};

export const getStripeKey = (region) => {
	if (!(region in stripeKeys)) {
		return stripeKeys[defaultStripeRegion];
	}
	return stripeKeys[region];
};

export const getStripeSubKeyIntention = (region) => {
	if (!(region in stripeSubKeyIntentions)) {
		return stripeSubKeyIntentions[defaultStripeRegion];
	}
	return stripeSubKeyIntentions[region];
};
